module.exports = __webpack_public_path__ + "img/win-cup.a91b1aa5.png";